import { i18n } from '../../i18n';




export const filterColumnsHash = {
  name_cont: {
    label: i18n.t('designer.name'),
    renderCell: {
      component: 'input'
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('designer.id'),
    width: 80,
  },
  name: {
    label: i18n.t('designer.name'),
  },
  created_at: {
    label: i18n.t('designer.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('designer.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  avatar: {
    label: i18n.t('designer.avatar'),
    width: 120,
    renderCell: 'storageAttachment',
  },
}

export const formColumnsHash = {
  name: {
    label: i18n.t('designer.name'),
    renderCell: {
      component: 'input',
    },
  },
  avatar: {
    label: i18n.t('designer.avatar'),
    width: 120,
    renderCell: {
      component: 'upload',
    }
  },
}
